<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="90px" @handleConfirm="handleConfirm">
    <el-form-item :label="$t('BusinessImportHistory.page.ColumnNumber')" prop="columnIndex">
      <BjInputNumber v-model="form.columnIndex" :min="0" not-auto-zero />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.ColumnCode')" prop="columnCode">
      <BjInput v-model="form.columnCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.ColumnName')" prop="columnName">
      <BjInput v-model="form.columnName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.ColumnType')" prop="columnType">
      <BjSelectLov v-model="form.columnType" lov-code="HIMP.TEMPLATE.COLUMNTYPE" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.FormatMask')" prop="formatMask">
      <BjDateTimerPicker v-model="form.formatMask" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.Length')" prop="length">
      <BjInputNumber v-model="form.length" :min="0" not-auto-zero />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.Maximum')" prop="minValue">
      <BjInput v-model="form.minValue" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.Minimum')" prop="maxValue">
      <BjInput v-model="form.maxValue" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.ValidateValue')" prop="validateSet">
      <BjInput v-model="form.validateSet" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.RegularExpression')" prop="regularExpression">
      <BjInput v-model="form.regularExpression" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.SampleData')" prop="sampleData">
      <BjInput v-model="form.sampleData" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.Description')" prop="description">
      <BjInput v-model="form.description" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
    </el-form-item>
    <el-form-item :label="$t('enableText')" prop="enabledFlag">
      <el-switch v-model="form.enabledFlag" :active-value="1" :inactive-value="0" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.NullAllowed')" prop="nullableFlag">
      <el-switch v-model="form.nullableFlag" :active-value="1" :inactive-value="0" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.DataValidation')" prop="validateFlag">
      <el-switch v-model="form.validateFlag" :active-value="1" :inactive-value="0" />
    </el-form-item>
    <el-form-item :label="$t('BusinessImportHistory.page.ValueConversion')" prop="changeDataFlag">
      <el-switch v-model="form.changeDataFlag" :active-value="1" :inactive-value="0" />
    </el-form-item>
  </BjDrawerForm>
</template>
<script>
import { importApi } from '@/api';
const getDefaultForm = () => {
  return {
    changeDataFlag: 0,
    columnCode: null,
    columnIndex: null,
    columnName: null,
    columnType: null,
    columnTypeMeaning: null,
    description: null,
    enabledFlag: 1,
    formatMask: null,
    id: null,
    length: null,
    maxValue: null,
    minValue: null,
    nullableFlag: 0,
    regularExpression: null,
    sampleData: null,
    targetId: 0,
    templateLineTls: [
      {
        columnName: null,
        id: null,
        lang: null,
      },
    ],
    tenantId: 0,
    validateFlag: 0,
    validateSet: null,
  };
};

export default {
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        columnIndex: [{ required: true, message: this.$t('BusinessImportHistory.page.PleaseSerialNumber'), trigger: 'blur' }],
        columnCode: [{ required: true, message: this.$t('BusinessImportHistory.page.PleaseColumnNumber'), trigger: 'blur' }],
        columnName: [{ required: true, message: this.$t('BusinessImportHistory.page.PleaseColumnName'), trigger: 'blur' }],
        columnType: [{ required: true, message: this.$t('BusinessImportHistory.page.PleaseColumnType'), trigger: 'change' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('BusinessImportHistory.page.EditColumn') : this.$t('BusinessImportHistory.page.CreateColumn'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      API_DATA.targetId = this.id;

      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      this.sendApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },
    sendApi(data) {
      const API = this.isEdit ? 'putTemplateLines' : 'addTemplateLines';
      importApi[API](data).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
